@if (marketingBanners.length >= 1) {
  <div class="marketing-banner-carousel_slider">
    <div class="swiper-custom-prev marketing-banner-prev"></div>
    <swiper-container class="swiper-marketing-banner-carousel_slider" touch-action="none" data-swiper-parallax="100%"
      [direction]="config.direction"
      [initialSlide]="config.initialSlide"
      [observer]="config.observer"
      [simulateTouch]="config.simulateTouch"
      [pagination]="config.pagination"
      [watchSlidesProgress]="config.watchSlidesProgress"
      [preventInteractionOnTransition]="config.preventInteractionOnTransition"
      [centeredSlides]="config.centeredSlides"
      [slidesPerView]="config.slidesPerView"
      [spaceBetween]="config.spaceBetween"
      navigation='{ "nextEl": ".marketing-banner-next", "prevEl": ".marketing-banner-prev" }'
      (indexChange)="onIndexChange($event)"
      (swiperTouchStart)="handleTouchStart($event)" (swiperTouchMoveOpposite)="swiperTouch($event)">
      @for (banner of marketingBanners; track banner; let i = $index) {
        <swiper-slide>
          <div class="slider-item slide-item-{{ i }}">
            <div class="image" [style.background-image]="'url(' + banner.image_url + ')'">
            </div>
            <div class="content">
              <div class="body-wrapper">
                <p class="mat-display-medium u-text-no-margin"> {{ banner.heading }} </p>
                <p class="body" [innerHTML]="banner.body"></p>
              </div>
              @if (banner.service_id) {
                <button mat-raised-button color="primary" class="marketing-banner-btn"
                  (click)="routeToService(banner.service_index, banner.heading)">
                  {{ banner.button_text }}
                </button>
              }
              @if (banner.button_link) {
                <button mat-raised-button color="primary" class="marketing-banner-btn"
                  (click)="routeToExternalPage(banner.button_link, banner.heading)">
                  {{ banner.button_text }}
                </button>
              }
            </div>
          </div>
        </swiper-slide>
      }
    </swiper-container>
    <div class="swiper-custom-next marketing-banner-next"></div>
  </div>
}